/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import { PAYSLIP_REPORT_STATE } from "./payslip-report-constant";


const usePayslipReportService = () => {
    const [payslipReportTableUILoading, setPayslipReportTableUILoading] = useState(false);
    const [payslipReportListData, setPayslipReportListData] = useState([]);
    const [payslipReportSummary, setPayslipReportSummary] = useState({})
    const [payslipReportData, setPayslipReportData] = useState({})
    const { fetchData } = useAPIHandler()
    const [allowances, setAllowances] = useState([])
    const [payslipReportInputs, setPayslipReportInputs] = useState(PAYSLIP_REPORT_STATE)
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [searchQuery, setSearchQuery] = useState("")
    const [openUploadImportModal, setOpenUploadImportModal] = useState(false);
    const handleCloseUploadImportModal = () => setOpenUploadImportModal(false);
    const handleOpenUploadImportModal = () => setOpenUploadImportModal(true);
    const [dataFetched, setDataFetched] = useState(false);
    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }
        setPayslipReportInputs((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }))
    }
    // const extractAllowances = (data) => {
    //     const allAllowances = data.reduce((acc, salary) => {
    //         salary.allowance.forEach(allowance => {
    //             if (!acc.includes(allowance.allowance_name)) {
    //                 acc.push(allowance.allowance_name);
    //             }
    //         });
    //         return acc;
    //     }, []);
    //     setAllowances(allAllowances)
    // }
    const fetchAllPayslipReportEmpList = async () => {
        setPayslipReportTableUILoading(true);
        try {
            // const response = await fetchData({
            //     url: `/report/salary?month=1&year=2025`,
            //     method: 'GET'
            // })
            const { report_month } = payslipReportInputs;
            if (report_month) {
                const parts = report_month.split("-");
                const year = parts[0];
                let month = parts[1];
                if (month.startsWith("0")) {
                    month = month.substring(1);
                }
                // /report/payslip/23?month=1&year=2025
                const response = await fetchData({
                    url: `/report/salary?month=${month}&year=${year}&order_type=ASC&search=${searchQuery}`,
                    method: 'GET'
                });
                setPayslipReportListData(response?.data?.salary);
                setTotalPages(response?.data?.pagesNumber);
                setDataFetched(true)
            }
            setPayslipReportTableUILoading(false)
        } catch {
            setPayslipReportTableUILoading(false)
        }
    }

    // const handleClickEmpName = async (empID) => {
        
    //     handleOpenUploadImportModal()
    //     fetchPayslipReportById(empID)
    // }
    const handleClickEmpName = async (empID) => {
        setPayslipReportTableUILoading(true);
        try {
            await fetchPayslipReportById(empID);
            handleOpenUploadImportModal();
        } catch (error) {
            console.error("Error fetching payslip report:", error);
        } finally {
            setPayslipReportTableUILoading(false);
        }
    };
    const fetchPayslipReportById = async (empID) => {
        setPayslipReportTableUILoading(true);
        try {
            const { report_month } = payslipReportInputs;

            if (report_month) {
                const parts = report_month.split("-");
                const year = parts[0];
                let month = parts[1];
                if (month.startsWith("0")) {
                    month = month.substring(1);
                }
                // /report/payslip/23?month=1&year=2025
                const response = await fetchData({
                    url: `/report/payslip/${empID}?month=${month}&year=${year}`,
                    method: 'GET'
                });
                setPayslipReportData(response?.data);
            }

        } catch {
            setPayslipReportTableUILoading(false)
        }
    }
    useEffect(() => {
        fetchAllPayslipReportEmpList();
    }, [payslipReportInputs,rowsPerPage, currentPage, searchQuery])
    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    };

    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
    };

    const handleRowsPerPageChange = (value) => {
        setRowsPerPage(Number(value.target.value));
        setCurrentPage(0);
    };
    return {
        payslipReportListData,
        allowances,
        payslipReportSummary,
        payslipReportInputs,
        handleChange,
        openUploadImportModal,
        handleCloseUploadImportModal,
        handleOpenUploadImportModal,
        handleClickEmpName,
        payslipReportData,
        searchQuery,
        setSearchQuery,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        dataFetched
    }
}

export default usePayslipReportService